import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { Descriptor, RespSearch } from "../model/descriptor.model";
@Injectable({
  providedIn: "root",
})
export class DescriptorService {
  baseUrl = environment.baseUrl;
  constructor(private httpClient: HttpClient) {}

  get(id: string | number): Observable<Descriptor> {
    return this.httpClient.get<Descriptor>(`${this.baseUrl}descriptor/${id}`);
  }

  getAll(): Observable<Descriptor[]> {
    return this.httpClient.get<Descriptor[]>(`${this.baseUrl}descriptor`);
  }

  getSearch(descriptor_name: string): Observable<RespSearch> {
    const _route = "descriptor/search?filter=descriptor_name";
    const _descriptor_name = "&value=" + descriptor_name;
    return this.httpClient.get<RespSearch>(
      `${this.baseUrl}${_route}${_descriptor_name}`
    );
  }
}
